export enum STEPS {
  MAIN_OFFERS = 'MAIN_OFFERS',
  MINOR_OFFERS = 'MINOR_OFFERS'
}
